import React, { ReactElement, useContext, useEffect } from 'react';
import { FieldRendererProps } from '../FieldTableTypes';
import { FieldTableSettingsContext } from '../../../contexts/field-table-settings-context';
import {Link} from "@mui/material";
import {
    Link as RouterLink } from 'react-router-dom';

export function FieldTableLinkColumn(): ReactElement {
    const context = useContext(FieldTableSettingsContext);
    useEffect(() => {
        context.registerType({
            dataType: 'link',
            width: () => 'auto',
            className: () => 'column-wide-enough',
            readOnly:true,
            // eslint-disable-next-line react/display-name
            renderViewer: (props: FieldRendererProps<any>) => {
                console.log('PROPS ARE',props);
                const value = props.options?.getValue ? props.options.getValue(props) : props.field.value;
                const link = props.options.getLink(props);
                if(typeof link == 'string' && (link.startsWith('mailto:')||link.startsWith('https://'))) {
                    return (<a href={link}>{value}</a>);
                }
                return (<Link component={RouterLink} to={link}>{value}</Link>);
//                const value = props.options?.getValue ? props.options.getValue(props) : props.field.value;
                return value;
            },
            renderExport:(cell,props: FieldRendererProps<any>):any => {
                console.log('render link',props);
                let value = props.options?.getValue ? props.options.getValue(props) : props.field.value;
                const link = props.options.getLink(props);
                if(typeof link =='object') {
                    cell.v = value?value.toString():'';
                } else {
                    cell.t = 's';
                    cell.v = value;
                    cell.l = {Target:link};
                }
                return cell;
            }
        });
    }, [context]);
    return null;
}
